import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import ServicesDetails from './components/ServicesDetails';
import ScrollToTop from './components/ScrollToTop';
import JoinPartner from './components/JoinUsPartner';
import JoinPartnerBanner from './components/JoinPartnerBanner';

function App() {
  useEffect(() => {
    document.querySelectorAll('.set-bg').forEach(el => {
      const bg = el.getAttribute('data-setbg');
      if (bg) {
        el.style.backgroundImage = `url('/${bg}')`;
      }
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/joinus" element={<JoinPartner />} />
        <Route path="/joinusbanner" element={<JoinPartnerBanner />} />
        <Route path="/services-details" element={<ServicesDetails />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;